const type = 'SET_ACCOUNT_HOLDERS';

const setAccountHolders = (data) => ({
  type,
  data,
});

export { type };
export default setAccountHolders;
